import { toIsoString } from "../util/date.js";
export var setCurrentDateTime = function setCurrentDateTime() {
  return function (dispatch, getState, context) {
    dispatch({
      type: "TIME/CURRENT_DATE_TIME_UPDATED",
      payload: {
        currentDateTime: toIsoString(context.now())
      }
    });
  };
};